import { DefinedDefaults } from "@/ui/lib";
import { InputHTMLAttributes } from "react";
import { TIconKey } from "../../primitives";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const INPUT_TYPE_ICON_MAP: Partial<Record<TInputType, TIconKey>> = {
  search: "search",
};

export const WITH_ICON_CLASS = "pl-9";



/*-------------------------------------
|  Types
|-------------------------------------*/

export type TInputType =
  | "button"
  | "checkbox"
  | "color"
  | "date"
  | "datetime-local"
  | "email"
  | "file"
  | "hidden"
  | "image"
  | "month"
  | "number"
  | "radio"
  | "range"
  | "reset"
  | "search"
  | "submit"
  | "tel"
  | "text"
  | "time"
  | "url"
  | "week"
  | "password";

export type TInputIconProps = {
  type?: TInputType;
  icon?: TIconKey;
};

export type TInputFieldProps = InputHTMLAttributes<HTMLInputElement> & TInputIconProps & {
  error?: string;
};

export type TInputProps = {
  label: string;
  asChild?: boolean;
  hideLabel?: boolean;
} & Omit<TInputFieldProps, "type"> & TInputIconProps;


type TInputDefaultProps = DefinedDefaults<
  TInputProps,
  "type"
>;



/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const INPUT_DEFAULTS = {
  type: "text",
} satisfies TInputDefaultProps;
